module.exports = __webpack_public_path__ + "static/media/ic_02_ActualMicrosoft.570c6503.svg";